module.exports = __webpack_public_path__ + "img/jignjing.db54c84d.png";